import axios from 'axios';
import qs from 'qs';

export const axiosClient = axios.create({
  baseURL: '/api/internal/',
});

const ApiClient = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getUserSession: (locale: string): any => axiosClient.get(`${locale}/session/user`),

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getHomepage: (locale: string): any => axiosClient.get(locale),

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getLandingPage: (locale: string, slug: string): any =>
    axiosClient.get(`${locale}/specials/${slug}`),

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getHostPage: (locale: string, host: string): any => axiosClient.get(`${locale}/${host}`),

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSearchResults: (locale: string, queryString = ''): any => {
    const match = queryString.match(/^\??(.*)/);
    if (!match || match.length < 2) {
      return undefined;
    }
    return axiosClient.get(`${locale}/search?${match[1]}`);
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getIdSearch: (locale: string, displayId: string): any =>
    axiosClient.get(`${locale}/search/idsearch.json?display_id=${encodeURIComponent(displayId)}`),

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCountryList: (locale: string): any => axiosClient.get(`${locale}/search/countries_list`),

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getRegionList: (locale: string, countryCode: string): any =>
    axiosClient.get(`${locale}/search/region_list?country_code=${countryCode}`),

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCityList: (locale: string, countryCode: string, region: string): any =>
    axiosClient.get(`${locale}/search/city_list?country_code=${countryCode}&region_name=${region}`),

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  postInquiry: (locale: any, inquiry = {}): any =>
    axiosClient.post(`${locale}/inquiry`, { inquiry }),

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  postProcessingBooking: (locale: string, params: any): any =>
    axiosClient.post(`${locale}/processing/booking`, params),

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getBookingPrice: (locale: string, paymentMethod: string): any =>
    axiosClient.get(
      `${locale}/processing/booking/calculate_payment_method?payment_method=${paymentMethod}`,
    ),

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  postProcessingCheckCosts: (locale: string, params = {}): any =>
    axiosClient.post(`${locale}/processing/booking/check_costs`, params),

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  postProcessingReserve: (locale: string): any =>
    axiosClient.post(`/${locale}/processing/booking/reserve`, {}),
};

export default ApiClient;
